/* eslint-disable no-unused-vars */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/header.css";
import BottomBar from "../../components/ui/BottomBar/BottomBar";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import LanguageSwitcher from "../../components/ui/LanguageSwitcher/LanguageSwitcher";

const HeaderComponent = ({ title, onBack, showRightMenu = true }) => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <>
      <header className="main-header">
        <div className="tHead">
          {onBack && !isDesktop && (
            <a onClick={handleBack} className="back-button" href="#"></a>
          )}

          {title !== "" ? (
            <div className="tTitle">
              <h2 className="text-md">{title}</h2>
            </div>
          ) : (
            <div style={{ width: !isDesktop ? "100%" : "auto" }}>
              <img
                alt="CTS"
                style={{ cursor: "pointer" }}
                onClick={handleHome}
                className="bHeadIcon"
                src="/assets/img/ci/icon/icon-aunjai.svg"
              />
            </div>
          )}
          {showRightMenu && (
            <div className="bRight">
              {isDesktop && (
                <div className="desktop-menu-wrapper">
                  <BottomBar />

                  <LanguageSwitcher />
                </div>
              )}
              {!isDesktop && (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <LanguageSwitcher />
                </div>
              )}
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default HeaderComponent;
